module.exports = __webpack_public_path__ + "media/images/redesign-images/home/home-1-large-32e3483e69dfb7c6bac112af3f91b955.jpg";